module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"text":"{dateTime} by {displayName}"}}')
  delete Component.options._Ctor
}
